export default __webpack_public_path__ + "static/media/clockimg.0fe1db64.png";